import { Component } from '@angular/core';
import { ClientDashboardTripPreparationComponent } from '@features/client-dashboard/components/client-dashboard-trip-preparation/client-dashboard-trip-preparation.component';
import { ClientDashboardComponent } from '@features/client-dashboard/components/client-dashboard/client-dashboard.component';
import { NavigationComponent } from '@features/navigation/components/navigation/navigation.component';

@Component({
    selector: 'app-client-dashboard-trip-preparation-page',
    standalone: true,
    imports: [
        NavigationComponent,
        ClientDashboardComponent,
        ClientDashboardTripPreparationComponent,
    ],
    templateUrl: './client-dashboard-trip-preparation-page.component.html',
    styles: ``,
})
export class ClientDashboardTripPreparationPageComponent {}
